import { useState } from 'react';
import { S } from '@/shared/constants/styles';
import { fieldLabelStyle } from '@/shared/components/FormField';

export default function LoginForm({ onLogin, error, loading }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(email, password);
  };

  return (
    <>
      {error && (
        <div style={{
          background: "#fef2f2", color: "#991b1b", border: "1px solid #fecaca",
          borderRadius: 10, padding: "10px 14px", fontSize: 13, marginBottom: 16, textAlign: "center",
        }}>
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <label style={fieldLabelStyle}>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          required
          style={{ ...S.input, marginBottom: 14 }}
        />
        <label style={fieldLabelStyle}>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Your password"
          required
          style={{ ...S.input, marginBottom: 20 }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{
            ...S.btn(loading ? "#93c5fd" : "#2563eb"),
            width: "100%", padding: 13, borderRadius: 10, fontSize: 15,
          }}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </>
  );
}
